import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CalendarCheck, Compass, Info, ShieldQuestion } from "lucide-react";
import { track } from "@/lib/analytics";

const CTA_MAP = {
  test: { title: "Ordina online la tua SENIORCAR", text: "Confermando l'ordine online accedi all'offerta dedicata. Nessun impegno fino alla conferma.", label: "Prenota Online", to: "/offerta", icon: CalendarCheck },
  discover: { title: "Scopri SENIORCAR", text: "Il dispositivo medico monoposto pensato per chi ha difficoltà motorie: senza patente né targa.", label: "Scopri SENIORCAR", to: "/seniorcar", icon: Compass },
  info: { title: "Richiedi informazioni", text: "Un consulente ti fornirà tutte le informazioni e un preventivo personalizzato.", label: "Richiedi informazioni", to: "/contatti", icon: Info },
  regulatory: { title: "Scopri se SENIORCAR può essere adatta alle tue esigenze", text: "Ti aiutiamo a capire la tua situazione e le possibili soluzioni.", label: "Scopri se fa per te", to: "/#scopri", icon: ShieldQuestion },
  local: { title: "Ordina online la tua SENIORCAR", text: "Confermi l'ordine online e il centro SENIORCAR più vicino ti segue fino alla consegna.", label: "Prenota Online", to: "/offerta", icon: CalendarCheck },
};

export const CtaBlock = ({ variant = "test" }) => {
  const c = CTA_MAP[variant] || CTA_MAP.test;
  const Icon = c.icon;
  return (
    <section className="rounded-3xl p-8 sm:p-12 text-center" style={{ backgroundColor: "var(--sc-emerald)" }} data-testid={`cta-block-${variant}`}>
      <Icon className="mx-auto text-white mb-4" size={44} />
      <h2 className="text-2xl sm:text-3xl font-bold text-white max-w-2xl mx-auto" style={{ fontFamily: "Outfit" }}>{c.title}</h2>
      <p className="text-white/85 mt-3 max-w-xl mx-auto text-lg">{c.text}</p>
      <Link to={c.to} className="inline-block mt-6">
        <Button className="h-14 px-8 text-lg font-bold text-white rounded-full bg-transparent border-2 border-white/70 hover:bg-white/10"
          data-testid={`cta-button-${variant}`} onClick={() => track("cta_click", { cta: variant })}>
          {c.label}
        </Button>
      </Link>
    </section>
  );
};
